<template>
  <div>
    <SapFilters
      :default="filters"
      @openModal="openModal = true"
      @update="handleFilters"
      @sapAdd="handleSapAdd"
    />

    <Loader :isVisible="isLoading" />

    <SapTable
      :clients="clients"
      :total="total"
      :currentPage="currentPage"
      :limit="limit"
      @updatePagination="handleCurrentChange"
    />
  </div>
</template>

<script>
import Loader from "@/components/utils/Loader";
import SapFilters from "@/components/sap/SapFilters";
import SapTable from "@/components/sap/SapTable";

export default {
  components: {
    SapFilters,
    SapTable,
    Loader,
  },

  data() {
    return {
      clients: [],
      filters: {
        clients: [],
        sapNumber: null,
        year: null,
        emailSended: "all",
      },
      isLoading: false,
      modalSendEmailShow: false,
      modalSendEmailValue: {},
      currentPage: 1,
      offset: 0,
      limit: "10",
      total: 0,
    };
  },

  async created() {
    await this.loadClientsSaps();
  },

  methods: {
    async loadClientsSaps(offset = 0) {
      try {
        this.isLoading = true;

        const { data } = await this.$api.get(`/saps`, {
          params: {
            clientFilter: this.filters.client && this.filters.client.value,
            sapNumber: this.filters.sapNumber,
            year: this.filters.year,
            emailSended: this.filters.emailSended,
            offset,
            limit: this.limit,
          },
        });
        this.clients = data.clients;
        this.total = data.total;
        this.limit = data.limit;
        this.offset = data.offset;
      } catch (e) {
        this.$errorToast("Impossible de charger les données");

        this.$router.push({
          name: "dashboard",
        });
      } finally {
        this.isLoading = false;
      }
    },

    async handleFilters(newFilters) {
      this.filters = newFilters;

      this.currentPage = 1;
      await this.loadClientsSaps();
    },

    async handleCurrentChange(val) {
      this.currentPage = val;
      this.offset = (val - 1) * this.limit;

      await this.loadClientsSaps(this.offset);
    },

    async handleSapAdd() {
      this.currentPage = 1;
      await this.loadClientsSaps();
    },

    async onModalSendEmailClose() {
      this.modalSendEmailShow = false;
    },
  },
};
</script>
